"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_react_1 = require("mobx-react");
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const SearchWithFilter_1 = __importDefault(require("@Components/Search/SearchWithFilter"));
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const Pagination_1 = __importDefault(require("@Components/Pagination"));
const SongwriterSummaryCard_1 = __importDefault(require("@Components/Cards/SongwriterSummaryCard"));
const SongwriterInternalScene = () => {
    var _a;
    const { songwriterSearchStore, popupStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [preloaderIsOpen, setPreloaderIsOpen] = (0, react_1.useState)(false);
    const [searchValue, setSearchValue] = (0, react_1.useState)();
    const limitItems = 50;
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('home_internal');
        eventGetSongwriters().then();
    }, [searchValue]);
    const eventGetSongwriters = (callBackPagination) => __awaiter(void 0, void 0, void 0, function* () {
        let pagination = {
            page: 1,
            limit: limitItems,
        };
        if (callBackPagination) {
            pagination = Object.assign(Object.assign({}, pagination), callBackPagination);
        }
        try {
            setPreloaderIsOpen(true);
            yield songwriterSearchStore.loadSongwriters(pagination, searchValue);
        }
        catch (ignore) {
            popupStore.setAlertData('Could not load songwriters', true);
        }
        finally {
            setPreloaderIsOpen(false);
        }
    });
    return (react_1.default.createElement("div", { className: 'home-internal-accounts-tab' },
        react_1.default.createElement("div", { className: "search-all-block" },
            react_1.default.createElement("p", null,
                songwriterSearchStore.songwriters && songwriterSearchStore.songwriters.totalElements,
                " Songwriters"),
            react_1.default.createElement(SearchWithFilter_1.default, { mainColor: true, id: 'songwriter-search', onChangeInput: () => { }, value: '', placeholder: 'Search Songwriters', withFilter: false, buttonClick: setSearchValue, onClearInput: () => setSearchValue('') })),
        react_1.default.createElement("div", { className: "accounts-block" },
            preloaderIsOpen ? (react_1.default.createElement(PointPreloader_1.default, null)) : ((_a = songwriterSearchStore.songwriters) === null || _a === void 0 ? void 0 : _a.content.map((item) => (react_1.default.createElement(SongwriterSummaryCard_1.default, Object.assign({ key: item.id }, item))))),
            !preloaderIsOpen &&
                songwriterSearchStore.songwriters &&
                !songwriterSearchStore.songwriters.totalElements && (react_1.default.createElement("p", { className: 'small no-results' }, "No Songwriters"))),
        react_1.default.createElement(Pagination_1.default, { limit: limitItems, paginationPages: songwriterSearchStore.paginationInfo, onChange: eventGetSongwriters })));
};
exports.default = (0, mobx_react_1.observer)(SongwriterInternalScene);
